type ThemeRecord = Record<string, string>


const lightBase: ThemeRecord = {
  background: '#FFFFFF',
  backgroundSecondary: '#F4F3F9',
  backgroundTertiary: '#F4F4F7',
  backgroundMuted: '#5E5A89',
  // state colors expected by Tamagui base components
  backgroundHover: '#F4F3F9',
  backgroundPress: '#E9E8EE',
  backgroundGrey: '#ECEBED',
  color: '#4A4A4A',
  colorHover: '#4A4A4A',
  colorPress: '#4A4A4A',
  colorSecondary: '#9B9B9B',
  textSecondary: '#9B9B9B',
  colorMuted: '#808080',
  colorLink: '#8985A8',
  white: '#FFFFFF',
  black: '#000000',
  red: '#FF0000',
  cobuYellow: '#FEC100',
  cobuYellow05: 'rgba(254, 193, 0, 0.5)',
  cobuOrange: '#FDB913',
  cobuPink: '#ED145B',
  cobuPink8: '#FFF5F5',
  cobuPink25: '#F9C5D8',
  cobuPink50: '#F68BAD',
  cobuPink75: '#F15185',
  cobuDarkBlue: '#272163',
  cobuDarkBlue10: 'rgba(39, 33, 99, 0.1)',
  cobuDarkBlue25: '#E9E8EE',
  cobuDarkBlue50: '#9490B1',
  cobuDarkBlue75: '#534F70',
  cobuTeal: '#00B5D1',
  cobuTeal50: '#BFECF3',
  cobuTopaz: '#16BBD2',
  cobuTopaz10: 'rgba(22, 187, 210, 0.1)',
  success: '#4ED293',
  error: '#EF4A4A',
  warning: '#FEAE35',
  info: '#4A6BDF',
  borderColor: '#DDDDDD',
  borderColorHover: '#C9C8D9',
  borderColorPress: '#B5B3C7',
  outlineColor: '#4A6BDF',
  borderColorLight: '#C9C8D9',
  lightBlueGray: '#C9C8D9',
  pinnedCommentGray: '#2721631A',
  iconColor: '#B0B0B0',
  floatingBarColor: '#F7F7F7',
  gray: '#808080',
  pageGrey: '#D9D9D9',
  cobuPinkRed: '#ec1659',
  reactionLike: '#00B5D1',
  reactionLove: '#F32E30',
  reactionClap: '#6D89ED',
  reactionSmile: '#FEC100',
  reactionLaugh: '#FEC100',
  whiteTransparent05: 'rgba(255, 255, 255, 0.05)',
  whiteTransparent10: 'rgba(255, 255, 255, 0.1)',
  whiteTransparent20: 'rgba(255, 255, 255, 0.2)',
  whiteTransparent40: 'rgba(255, 255, 255, 0.4)',
  whiteTransparent50: 'rgba(255, 255, 255, 0.5)',
  whiteTransparent60: 'rgba(255, 255, 255, 0.6)',
  whiteTransparent70: 'rgba(255, 255, 255, 0.7)',
  blackTransparent50: 'rgba(0, 0, 0, 0.5)',
  blackTransparent75: 'rgba(0, 0, 0, 0.75)',
  redTransparent10: 'rgba(255, 0, 0, 0.1)',
  redTransparent50: 'rgba(255, 0, 0, 0.5)',
  redTransparent80: 'rgba(255, 100, 100, 0.8)',
  greenTransparent10: 'rgba(0, 255, 0, 0.1)',
  avatar1: '#44C0D4',
  avatar2: '#4A6BDF',
  avatar3: '#F15185',
  avatar4: '#FDD019',
  avatar5: '#FEAE35',
  avatar6: '#4ED293',
  avatar7: '#A56BEE',
  avatar8: '#EF4A4A',
  buttonBackground: '#FEC100',
  buttonText: '#272163',
  buttonDisabledBackground: 'rgba(254, 193, 0, 0.5)',
  buttonDisabledText: '#9490B1',
  shadowGray: '#ccc',
  referralCustomizePrimary: '#EF1359',
  referralCustomizeSecondary: '#272164',
  referralStatsPrimary: '#5EA5C3',
  referralStatsSecondary: '#2D2E6E',
  dusk: '#5E5A89',
  // Tinted callout surface — the onboarding terms summary box and the brand badge chip.
  accentSurface: '#E7F0FF',
  accentSurfaceText: '#1B4FD8',
}

const darkBase: ThemeRecord = {
  background: '#272163',
  backgroundSecondary: '#3D3873',
  backgroundTertiary: '#534F70',
  backgroundMuted: '#5E5A89',
  // state colors expected by Tamagui base components
  backgroundHover: '#3D3873',
  backgroundPress: '#534F70',
  backgroundGrey: '#ECEBED',
  color: '#FFFFFF',
  colorHover: '#FFFFFF',
  colorPress: '#FFFFFF',
  colorSecondary: 'rgba(155, 155, 155, 1)',
  textSecondary: 'rgba(155, 155, 155, 1)',
  colorMuted: 'rgba(255, 255, 255, 0.6)',
  colorLink: '#BFECF3',
  white: '#FFFFFF',
  black: '#000000',
  red: '#FF0000',
  cobuYellow: '#FEC100',
  cobuYellow05: 'rgba(254, 193, 0, 0.5)',
  cobuOrange: '#FDB913',
  cobuPink: '#ED145B',
  cobuPink8: '#FFF5F5',
  cobuPink25: '#F9C5D8',
  cobuPink50: '#F68BAD',
  cobuPink75: '#F15185',
  cobuDarkBlue: '#272163',
  cobuDarkBlue10: 'rgba(39, 33, 99, 0.1)',
  cobuDarkBlue25: '#534F70',
  cobuDarkBlue50: '#9490B1',
  cobuDarkBlue75: '#E9E8EE',
  cobuTeal: '#00B5D1',
  cobuTeal50: '#BFECF3',
  cobuTopaz: '#16BBD2',
  cobuTopaz10: 'rgba(22, 187, 210, 0.1)',
  success: '#4ED293',
  error: '#EF4A4A',
  warning: '#FEAE35',
  info: '#4A6BDF',
  borderColor: 'rgba(255, 255, 255, 0.2)',
  borderColorHover: 'rgba(255, 255, 255, 0.3)',
  borderColorPress: 'rgba(255, 255, 255, 0.4)',
  outlineColor: '#4A6BDF',
  borderColorLight: 'rgba(255, 255, 255, 0.1)',
  lightBlueGray: 'rgba(255, 255, 255, 0.1)',
  pinnedCommentGray: '#534F70',
  iconColor: 'rgba(255, 255, 255, 0.7)',
  floatingBarColor: 'rgba(39, 33, 99, 0.8)',
  pageGrey: '#D9D9D9',
  cobuPinkRed: '#ec1659',
  reactionLike: '#00B5D1',
  reactionLove: '#F32E30',
  reactionClap: '#6D89ED',
  reactionSmile: '#FEC100',
  reactionLaugh: '#FEC100',
  whiteTransparent05: 'rgba(255, 255, 255, 0.05)',
  whiteTransparent10: 'rgba(255, 255, 255, 0.1)',
  whiteTransparent20: 'rgba(255, 255, 255, 0.2)',
  whiteTransparent40: 'rgba(255, 255, 255, 0.4)',
  whiteTransparent50: 'rgba(255, 255, 255, 0.5)',
  whiteTransparent60: 'rgba(255, 255, 255, 0.6)',
  whiteTransparent70: 'rgba(255, 255, 255, 0.7)',
  blackTransparent50: 'rgba(0, 0, 0, 0.5)',
  blackTransparent75: 'rgba(0, 0, 0, 0.75)',
  redTransparent10: 'rgba(255, 0, 0, 0.1)',
  redTransparent50: 'rgba(255, 0, 0, 0.5)',
  redTransparent80: 'rgba(255, 100, 100, 0.8)',
  greenTransparent10: 'rgba(0, 255, 0, 0.1)',
  avatar1: '#44C0D4',
  avatar2: '#4A6BDF',
  avatar3: '#F15185',
  avatar4: '#FDD019',
  avatar5: '#FEAE35',
  avatar6: '#4ED293',
  avatar7: '#A56BEE',
  avatar8: '#EF4A4A',
  buttonBackground: '#FEC100',
  buttonText: '#272163',
  buttonDisabledBackground: 'rgba(254, 193, 0, 0.5)',
  buttonDisabledText: '#534F70',
  shadowGray: '#ccc',
  referralCustomizePrimary: '#EF1359',
  referralCustomizeSecondary: '#272164',
  referralStatsPrimary: '#5EA5C3',
  referralStatsSecondary: '#2D2E6E',
  dusk: '#5E5A89',
  accentSurface: 'rgba(107, 158, 255, 0.16)',
  accentSurfaceText: '#9FC0FF',
}

var entrataBase = {
  ...lightBase,
  background: "#F6F6F6",
  backgroundSecondary: "#FFFFFF",
  backgroundTertiary: "#FFFFFF",
  backgroundMuted: "#4A4A4A",
  backgroundHover: "#EDEDED",
  backgroundPress: "#DCDCDC",
  backgroundGrey: "#F6F6F6",
  color: "#000000",
  colorHover: "#000000",
  colorPress: "#000000",
  colorSecondary: "#4A4A4A",
  textSecondary: "#4A4A4A",
  colorMuted: "#5C5C5C",
  colorLink: "#16a34a",
  cobuYellow: "#71f99e", // mint
  cobuYellow05: "rgba(113, 249, 158, 0.5)",
  cobuOrange: "#71f99e",
  cobuPink: "#000000",
  cobuPink8: "rgba(255, 255, 255, 0.08)",
  cobuPink25: "rgba(255, 255, 255, 0.25)",
  cobuPink50: "rgba(255, 255, 255, 0.5)",
  cobuPink75: "rgba(255, 255, 255, 0.75)",
  cobuDarkBlue: "#000000",
  cobuDarkBlue10: "rgba(0, 0, 0, 0.1)",
  cobuDarkBlue25: "rgba(0, 0, 0, 0.25)",
  cobuDarkBlue50: "rgba(0, 0, 0, 0.5)",
  cobuDarkBlue75: "rgba(0, 0, 0, 0.75)",
  cobuTeal: "rgb(75, 85, 99)",
  cobuTeal50: "rgba(75, 85, 99, 0.5)",
  cobuTopaz: "#16a34a",
  cobuTopaz10: "rgba(113, 249, 158, 0.1)",
  info: "#71f99e",
  borderColor: "#DDDDDD",
  borderColorHover: "#C8C8C8",
  borderColorPress: "#B0B0B0",
  outlineColor: "#006BFF",
  borderColorLight: "#E5E5E5",
  lightBlueGray: "#E0E0E0",
  pinnedCommentGray: "rgba(0, 0, 0, 0.08)",
  iconColor: "#4A4A4A",
  floatingBarColor: "#FFFFFF",
  pageGrey: "#F6F6F6",
  buttonBackground: "#000000",
  buttonText: "#FFFFFF",
  buttonDisabledBackground: "#C8C8C8",
  buttonDisabledText: "#FFFFFF",
  shadowGray: "#D3D3D3",
  referralCustomizePrimary: "#000000",
  referralCustomizeSecondary: "#4A4A4A",
  referralStatsPrimary: "#ffffff",
  referralStatsSecondary: "#000000",
  cardBackground: "#FFFFFF",
  cardBorderColor: "#DDDDDD",
  pageBackground: "#F6F6F6",
  buttonSecondaryBackground: "#F6F6F6",
  buttonSecondaryText: "#000000",
  buttonSecondaryBorderColor: "#DDDDDD",
  buttonTertiaryBackground: "#000000",
  buttonTertiaryText: "#FFFFFF",
  textLinkColor: "#006BFF",
  headlineColor: "#000000",
  subheadlineColor: "#000000",
  bodyBoldColor: "#000000",
  smallBodyBoldColor: "#000000",
  paragraphColor: "#4A4A4A",
  tooltipBannerYellow: '#f5c842',
  termsSlogan:"#CFC3B0"
};


export const lightTheme = lightBase
export const darkTheme = darkBase
export const entrataTheme = entrataBase
export const themes = { light: lightTheme, dark: darkTheme, entrata: entrataTheme }
